import React from 'react'

import clsx from 'clsx'

import Tag from 'components/Tag'
import Tooltip from 'components/Tooltip'
import { useEventContext } from 'context/EventContext'

import classes from './TagWithHover.module.scss'

const data = {
  'Requested anonymity': {
    label: 'Requested anonymity',
    tooltipText: 'This verified reviewer requested to keep their identity confidential.',
    color: 'grey',
    event: {
      engagementDestination: 'show_requested-anonymity-definition',
      engagementDetails: 'hover_requested-anonymity',
    },
  },
  'Incentivized review': {
    label: 'Incentivized review',
    tooltipText: 'This reviewer was invited to submit an honest review and offered a nominal incentive as a thank you.',
    color: 'grey',
    event: {
      engagementDestination: 'show_incentivized-review-definition',
      engagementDetails: 'hover_incentivized-review',
    },
  },
  'Verified review': {
    label: 'Verified review',
    tooltipText: 'GetApp verified the legitimacy of this person’s usage of the product.',
    color: 'grey',
    event: {
      engagementDestination: 'show_verified-review-definition',
      engagementDetails: 'hover_verified-review',
    },
  },
  'Frequent user': {
    label: 'Frequent user',
    tooltipText: 'The reviewer used the software intensively for at least 6 months on a weekly or a daily basis.',
    color: 'teal',
    event: {
      engagementDestination: 'show_frequent-user-definition',
      engagementDetails: 'hover_frequent-user',
    },
  },
  'Organic review': {
    label: 'Organic review',
    tooltipText: 'The reviewer was not provided any incentive for completing this review.',
    color: 'grey',
    event: {
      engagementDestination: 'show_organic-review-definition',
      engagementDetails: 'hover_organic-review',
    },
  },
  'Highly relevant': {
    label: 'Highly relevant',
    tooltipText:
      'This review was submitted within the last 12 months and is considered relevant to the current state of product performance.',
    color: 'teal',
    event: {
      engagementDestination: 'show_highly-relevant-definition',
      engagementDetails: 'hover_highly-relevant',
    },
  },
}

/** @type {import('./types').default} */
const TagWithHover = ({ variant = 'Requested anonymity', customVariant, size }) => {
  const { label, tooltipText, color, event } = customVariant || data[variant]
  const { sendEvent } = useEventContext({ name: 'engagement_hover' })

  return (
    <Tooltip
      title={tooltipText}
      enterTouchDelay={100}
      sendOnEnterEvents={() =>
        sendEvent({
          ...event,
        })
      }
    >
      <Tag color={color} className={clsx(classes.root, classes[color])} size={size}>
        {label}
      </Tag>
    </Tooltip>
  )
}
export default TagWithHover
